import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import searchSlice from "../features/search/search-slice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import CompanyCard from "../Components/Company/CompanyCard";

function LLMCompare() {
  const dispatch = useDispatch();

  const globalLoading = useSelector((state) => state.search.globalLoading);

  const [companies, setCompanies] = useState([]);

  const [query, setQuery] = useState("");
  const [answer, setAnswer] = useState("");

  const companyOptions = [
    { value: "procter & gamble", label: "procter & gamble" },
    { value: "oliver wyman", label: "oliver wyman" },
    { value: "molex", label: "molex" },
    {
      value: "melaleuca:the wellness company",
      label: "melaleuca:the wellness company",
    },
    { value: "dyson", label: "dyson" },
    { value: "lane bryant", label: "lane bryant" },
    { value: "edcon", label: "edcon" },
    { value: "hitachi", label: "hitachi" },
    { value: "gordon food service", label: "gordon food service" },
    { value: "bass pro shops", label: "bass pro shops" },
    { value: "legrand", label: "legrand" },
    { value: "new york & company", label: "new york & company" },
    { value: "sonoco", label: "sonoco" },
    { value: "liverpool", label: "liverpool" },
  ];
  const handleCompanyChange = (selectedOption) => {
    setCompanies(selectedOption);
    // console.log(selectedOption);
  };

  var companyArray = [];
  companies.map((company) => {
    companyArray.push(company.value);
  });

  const [chosenCompanies, setChosenCompanies] = useState([]);

  const getChosenCompaniesData = (e) => {
    e.preventDefault();
    dispatch(searchSlice.actions.setGlobalLoading(true));
    axios
      .post(process.env.REACT_APP_BACKEND_URL + `/multiCompanies`, {
        ListOfCompanies: companyArray,
      })
      .then((response) => {
        setChosenCompanies(response.data.Data);
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {
        dispatch(searchSlice.actions.setGlobalLoading(false));
      });
  };

  const llmSearch = (e) => {
    e.preventDefault();
    dispatch(searchSlice.actions.setGlobalLoading(true));
    axios
      .post(process.env.REACT_APP_BACKEND_URL + `/palmChat`, {
        ListOfCompanies: chosenCompanies,
        Query: query,
      })
      .then((response) => {
        setAnswer(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      })
      .finally(() => {
        dispatch(searchSlice.actions.setGlobalLoading(false));
      });
  };

  useEffect(() => {
    dispatch(searchSlice.actions.setPageNo(2));
    document.title = "SupPer - LLM";
  }, []);

  return (
    <div className="flex flex-col h-full mt-4 gap-2 mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <form className="w-full" onSubmit={getChosenCompaniesData}>
        <CreatableSelect
          required
          options={companyOptions}
          onChange={handleCompanyChange}
          value={companies}
          isSearchable
          isMulti
          placeholder="Choose multiple companies to compare"
          className="rounded-md p-2 mx-auto w-full"
        />
      </form>

      {companies.length > 0 && (
        <div className="text-xl text-white font-bold w-full text-center">
          Companies Chosen
        </div>
      )}
      <div className="flex items-center w-full p-4 border-2 border-gray-600 rounded-md bg-white">
        {globalLoading && (
          <img
            src="https://i.pinimg.com/originals/b0/45/af/b045af8a94343e3b1fdbf1576e9818b8.gif"
            className="w-1/3 mx-auto"
          />
        )}
        {!globalLoading && (
          <div className="flex flex-wrap justify-around  w-full  p-2 md:p-4">
            {chosenCompanies?.map((s) => {
              return <CompanyCard supplier={s} key={s.Cost} />;
            })}
          </div>
        )}
      </div>

      {companies.length > 0 && (
        <form className="w-full" onSubmit={llmSearch}>
          <input
            type="text"
            id="query"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
            placeholder="Ask AI anything about these suppliers. Ex. What is the average cost of these suppliers?"
            class="mt-1 w-full rounded-md border-yellow-500 shadow-sm sm:text-sm outline-none p-4 border-4"
          />
        </form>
      )}
      <div className="text-xl text-white font-bold w-full text-center">
        {answer}
      </div>
    </div>
  );
}

export default LLMCompare;
